export const mobileViewTypes = {
  // Management Action Bar
  SET_MANAGEMENT_ACTION_BAR_STATUS: "SET_MANAGEMENT_ACTION_BAR_STATUS",
  SET_SHOW_FILTERS_STATUS: "SET_SHOW_FILTERS_STATUS",
};
